import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import icon from "/favicon.svg";
import packageFile from "../../../package.json";

function Footer() {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      py={1}
      px={4}
      sx={{ boxShadow: (theme) => theme.shadows[9] }}
    >
      <img src={icon} height={40} />
      <Stack flexDirection={"row"} justifyContent={"center"} gap={4} flex={1}>
        <Typography color="text.secondary">Term of use</Typography>
        <Typography color="text.secondary">Privacy policy</Typography>
        <Typography color="text.secondary">Cookies</Typography>
        <Typography color="text.secondary">About AssuredPay</Typography>
      </Stack>
      <Box>
        <Typography variant="body2" color="text.secondary" textAlign={"right"}>
          © 2025 AssuredPay | All rights reserved
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign={"right"}
          // sx={{
          //   position: "fixed",
          //   right: 20,
          //   bottom: 4,
          //   zIndex: 10,
          // }}
        >
          Last Updated :- {packageFile.lastUpdated}
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
